class MediaGallery extends HTMLElement {
  constructor() {
    super();
    const productId = this.dataset.productId;
    this.elements = {
      liveRegion: this.querySelector(`[id^="GalleryStatus-${productId}"]`),
      viewer: this.querySelector(`slider-component[id^="GalleryViewer-${productId}"]`),
      thumbnails: this.querySelector(`[id^="GalleryThumbnails-${productId}"]`),
    };
    this.mql = globalThis.matchMedia('(min-width: 990px)');
    this.elements.thumbnails && this.setupEventListeners();
    this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches && this.removeListSemantic();
    let buttonsWrapper = this.querySelector('.configurator_slider-buttons');
    let gallery = document.querySelector(`[id="MediaGallery-${productId}"]`);
    let prev = buttonsWrapper?.querySelector('.slider-prev');
    let next = buttonsWrapper?.querySelector('.slider-next');
    close = this.querySelector('.close-button');
    (prev?.addEventListener('click', function () {
      gallery?.previousSlide();
    }),
      next?.addEventListener('click', function () {
        gallery?.nextSlide();
      }),
      close?.addEventListener('click', function () {
        const lastNonConfiguratorPage = localStorage.getItem('lastNonConfiguratorPage');
        lastNonConfiguratorPage ? globalThis.location.assign(lastNonConfiguratorPage) : globalThis.location.assign('/');
      }));
  }
  setupEventListeners() {
    (this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500)),
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', () => {
          this.setActiveMedia(mediaToSwitch.dataset.target, false, 'click');
        });
      }));
  }
  onSlideChanged(event) {
    if (window.innerWidth < 990) {
      const newMediaId = event.detail.currentElement.dataset.mediaId;
      const currentActive = this.elements.viewer.querySelector('.is-active');
      if (currentActive && currentActive.dataset.mediaId === newMediaId) return;
      this.setActiveMedia(newMediaId, false, 'auto');
    }
  }
  setActiveMedia(mediaId, prepend, event) {
    const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
    let videoElement = activeMedia.querySelector('video');
    if (
      (this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      }),
      activeMedia.classList.add('is-active'),
      videoElement?.load(),
      prepend)
    ) {
      if ((activeMedia.parentElement.prepend(activeMedia), this.elements.thumbnails)) {
        const activeThumbnail2 = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        activeThumbnail2.parentElement.prepend(activeThumbnail2);
      }
      this.elements.viewer.slider && this.elements.viewer.resetPages();
    }
    if (
      (this.preventStickyHeader(),
      globalThis.setTimeout(() => {
        (this.elements.thumbnails && activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft }),
          (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') &&
            activeMedia.scrollIntoView({ behavior: 'instant' }));
      }),
      this.playActiveMedia(activeMedia),
      !this.elements.thumbnails)
    )
      return;
    const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
    (this.setActiveThumbnail(activeThumbnail),
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition));
  }
  setActiveThumbnail(thumbnail) {
    if (!this.elements.thumbnails || !thumbnail) return;
    (thumbnail.querySelector('button').click(),
      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current')),
      thumbnail.querySelector('button').setAttribute('aria-current', 'true'));
    const slider = this.querySelector('.thumbnail-list.slider--mobile');
    if (!slider) return;
    const sliderRect = slider.getBoundingClientRect(),
      thumbnailRect = thumbnail.getBoundingClientRect(),
      slideWidth = thumbnailRect.right - thumbnailRect.left;
    if (!(thumbnailRect.left >= sliderRect.left && thumbnailRect.right <= sliderRect.right)) {
      const slidesSkipped = Math.ceil((sliderRect.left - thumbnailRect.right) / slideWidth),
        scrollAmount =
          thumbnailRect.left < sliderRect.left
            ? -Math.abs(slidesSkipped * slideWidth) - sliderRect.left
            : Math.abs(slidesSkipped * slideWidth) - sliderRect.left;
      slider.scrollBy({ left: scrollAmount, behavior: 'instant' });
    }
  }
  announceLiveRegion(activeItem, position) {
    const image = activeItem.querySelector('.product__modal-opener--image img');
    image &&
      ((image.onload = () => {
        (this.elements.liveRegion.setAttribute('aria-hidden', 'false'),
          (this.elements.liveRegion.innerHTML = globalThis.accessibilityStrings.imageAvailable.replace(
            '[index]',
            position,
          )),
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', 'true');
          }, 2e3));
      }),
      (image.src = image.src));
  }
  playActiveMedia(activeItem) {
    globalThis.pauseAllMedia(this.elements.viewer);
    const deferredMedia = activeItem.querySelector('.deferred-media');

    if (deferredMedia) {
      deferredMedia.style.visibility = 'visible';
      deferredMedia.style.pointerEvents = 'auto';
      deferredMedia.style.zIndex = '5';

      deferredMedia.loadContent(false);

      const video = activeItem.querySelector('video');
      if (video) {
        video.style.visibility = 'visible';
        video.style.pointerEvents = 'auto';

        // Adjust height after video metadata is loaded
        video.addEventListener('loadedmetadata', () => {
          const aspectRatio = video.videoHeight / video.videoWidth;
          const containerWidth = deferredMedia.clientWidth;
          const calculatedHeight = containerWidth * aspectRatio;
          const minHeight = 300;
          const viewportHeight = window.innerHeight;
          const maxHeight = viewportHeight * 0.8;
          const computedHeight = Math.max(calculatedHeight, minHeight);

          const finalHeight = Math.min(computedHeight, maxHeight);

          Object.assign(video.style, {
            height: finalHeight + 'px',
            maxHeight: '80vh',
            margin: '0 auto',
          });

          Object.assign(deferredMedia.style, {
            height: finalHeight + 'px',
            maxHeight: '80vh',
            display: 'flex',
            justifyContent: 'center',
          });
        });

        video.play();
      }

      setTimeout(() => {
        activeItem.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'center' });
      }, 100);
    }
  }
  preventStickyHeader() {
    ((this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header')),
      this.stickyHeader?.dispatchEvent(new Event('preventHeaderReveal')));
  }
  removeListSemantic() {
    this.elements.viewer.slider &&
      (this.elements.viewer.slider.setAttribute('role', 'presentation'),
      this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation')));
  }
  // The ordered set of slides the arrows should cycle through. The old prev/next
  // logic paged only through `.slide-show` slides, which collapses to the single
  // featured image whenever every photo has a unique alt (as on the Flow products,
  // where SEO alt text makes `filterMedia` match just one) — so next did nothing
  // and prev jumped to the hidden last slide, at every breakpoint.
  //
  // We derive the set from the thumbnail "dots" instead, because that's the actual
  // navigation UI the theme renders and it's reliable in every layout: on desktop
  // the main slider is a one-at-a-time fader (all but the active slide are
  // display:none, so the main slides can't be filtered by their own display), while
  // on mobile it's a swipe carousel. The visible thumbnails ([data-target], minus
  // the hidden variant duplicates) map 1:1 to the reachable main slides, in order.
  navigableSlides() {
    const slider = this.elements.viewer.slider;
    const thumbnails = this.elements.thumbnails
      ? Array.from(this.elements.thumbnails.querySelectorAll('[data-target]')).filter(
          (thumb) => getComputedStyle(thumb).display !== 'none',
        )
      : [];
    const fromThumbnails = thumbnails
      .map((thumb) => slider.querySelector(`[data-media-id="${thumb.dataset.target}"]`))
      .filter(Boolean);
    if (fromThumbnails.length) return fromThumbnails;
    // No thumbnails present: fall back to whatever slides are actually on screen.
    return Array.from(slider.querySelectorAll('.slider__slide')).filter(
      (slide) => getComputedStyle(slide).display !== 'none',
    );
  }
  activeSlideIndex(slides) {
    const active = this.elements.viewer.slider.querySelector('.is-active');
    const id = active && active.dataset.mediaId;
    return slides.findIndex((slide) => slide.dataset.mediaId === id);
  }
  nextSlide() {
    const slides = this.navigableSlides();
    if (!slides.length) return;
    const index = this.activeSlideIndex(slides);
    const target = slides[index < 0 ? 0 : (index + 1) % slides.length];
    this.setActiveMedia(target.dataset.mediaId, false, 'auto');
  }
  previousSlide() {
    const slides = this.navigableSlides();
    if (!slides.length) return;
    const index = this.activeSlideIndex(slides);
    const target = slides[index < 0 ? slides.length - 1 : (index - 1 + slides.length) % slides.length];
    this.setActiveMedia(target.dataset.mediaId, false, 'auto');
  }
}
customElements.get('media-gallery') || customElements.define('media-gallery', MediaGallery);
//# sourceMappingURL=/s/files/1/0636/0265/5480/t/58/assets/media-gallery.js.map?v=1729181726